import type { OpportunityFilter } from '@carboncopyco/types';
import { InlineLink, TextBase, TextCaption } from '@carboncopyco/ui';

type OpportunityDropdownEmptyStateProps = {
  disconnected: boolean;
  filter: OpportunityFilter;
  query: string;
  handleToggleFilter: (filter: OpportunityFilter) => void;
};

export const OpportunityDropdownEmptyState = ({
  disconnected,
  filter,
  query,
  handleToggleFilter,
}: OpportunityDropdownEmptyStateProps) => {
  if (disconnected) {
    return (
      <div className="grow w-full flex flex-col items-center justify-center gap-2">
        <TextCaption
          label="Something went wrong"
          color="text-ds-natural-600"
        />
        <TextCaption label="Please contact your admin to reconnect the integration" />
      </div>
    );
  }

  if (filter === 'opportunitiesExceptCurrentUser' && !query) {
    return (
      <div className="flex justify-center items-center">
        <TextBase label="Try typing something to get suggestions" />
      </div>
    );
  }

  return (
    <div className="grow w-full flex flex-col items-center justify-center gap-2">
      <>
        <TextCaption label="Nothing matches your search." />
        {filter === 'opportunitiesOwnedByCurrentUser' ? (
          <InlineLink
            as="button"
            label="Search for opportunities owned by others"
            onClick={() => {
              handleToggleFilter('opportunitiesExceptCurrentUser');
            }}
          />
        ) : (
          <InlineLink
            as="button"
            label="Search for opportunities you own"
            onClick={() => {
              handleToggleFilter('opportunitiesOwnedByCurrentUser');
            }}
          />
        )}
      </>
    </div>
  );
};
